module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-box"
  }, [_c('div', {
    staticClass: "site-top"
  }, [_c('div', {
    staticClass: "container g-clearfix"
  }, [_c('ul', {
    staticClass: "left-top-menu"
  }, [_c('li', [_c('span', {
    staticClass: "js-page-wodedingdan",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("您好！欢迎来到顾家家居！")])]), _vm._v(" "), (!_vm.login) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("登录")])], 1) : _vm._e(), _vm._v(" "), (!_vm.login) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (!_vm.login) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/register?type=register"
    }
  }, [_vm._v("注册")])], 1) : _c('li', {
    on: {
      "click": _vm._loginOut
    }
  }, [_vm._v("退出登陆")]), _vm._v(" "), (!_vm.login) ? _c('li', {
    on: {
      "click": _vm.undesignlogin
    }
  }, [_vm._v("设计圈")]) : _vm._e(), _vm._v(" "), (_vm.login) ? _c('li', {
    on: {
      "click": _vm.designlogin
    }
  }, [_vm._v("设计圈")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "top-menu"
  }, [_c('li', [_c('div', {
    staticClass: "header-cart",
    attrs: {
      "slot": "title"
    },
    on: {
      "click": function($event) {
        return _vm.linkTo({
          path: '/cart'
        })
      }
    },
    slot: "title"
  }, [_c('img', {
    staticClass: "cart-img",
    attrs: {
      "src": "/static/images/cart-home.png",
      "alt": ""
    }
  }), _vm._v("\n              购物车\n              "), _c('span', {
    staticClass: "cart-num"
  }, [_c('i', {
    staticClass: "num",
    class: {
      no: _vm.cartCount <= 0
    }
  }, [_vm._v(_vm._s(_vm.cartCount))])])])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('div', {
    attrs: {
      "slot": "title"
    },
    on: {
      "click": function($event) {
        return _vm.linkTo({
          path: '/user/orderList'
        })
      }
    },
    slot: "title"
  }, [_vm._v("\n              订单中心\n            ")])]), _vm._v(" "), _c('li', [_c('div', {
    attrs: {
      "slot": "title"
    },
    on: {
      "click": function($event) {
        return _vm.Jump('https://www.kukahome.com/serverCoop/HelpCenter')
      }
    },
    slot: "title"
  }, [_vm._v("\n              帮助中心\n            ")])]), _vm._v(" "), _c('li', [_c('div', {
    attrs: {
      "slot": "title"
    },
    on: {
      "click": function($event) {
        return _vm.Jump('https://gw.kukahome.com/website')
      }
    },
    slot: "title"
  }, [_vm._v("\n              官方网站\n            ")])])])])]), _vm._v(" "), _c('div', [_c('header', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "w-box"
  }, [_c('div', {
    staticClass: "nav-logo",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/home'
        })
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoSrc,
      "alt": "无"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('div', {
    staticClass: "nav-list"
  }, [_c('img', {
    staticClass: "search-img",
    attrs: {
      "src": "/static/images/search.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "输入商品名称...",
      "minlength": 1,
      "maxlength": 400
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleIconClick($event)
      }
    },
    model: {
      value: (_vm.goods_name),
      callback: function($$v) {
        _vm.goods_name = $$v
      },
      expression: "goods_name"
    }
  })], 1)])])])]), _vm._v(" "), (_vm.isNav) ? _c('div', [_vm._t("nav", [_c('Nav', {
    attrs: {
      "st": _vm.st,
      "cateList": _vm.cateList,
      "data": _vm.navConfig
    },
    on: {
      "change": _vm.changeGoods,
      "selCate": _vm.selCate
    }
  })])], 2) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "填写邮箱",
      "visible": _vm.designModalVisible,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.designModalVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "rules": [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change'],
        } ]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("邮箱只能联系管理员更改，请仔细确认。")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.designModalVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmail(_vm.form)
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-e80aae98","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header.vue
// module id = 716
// module chunks = 0 2 4 5 8 10 11 14 15 16 17 18